import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function GetAll() {
    return await createAxios().get("/DoctorsSpecialisation/GetAll")
}

export async function GetById(id) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/DoctorsSpecialisation/GetById?Id=" + id)
}

export async function Add(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/DoctorsSpecialisation/Add", param)
}

export async function Edit(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/DoctorsSpecialisation/Edit", param)
}

export async function Remove(id) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/DoctorsSpecialisation/Remove?Id=" + id)
}

